import axios from 'axios';
import { header } from '../components/header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

const normalizeAsk = (raw) => {
  const resolved = raw?.response ?? raw;
  if (!resolved) {
    return null;
  }

  if (Array.isArray(resolved)) {
    return (
      resolved.find((item) => isAskActive(item)) ||
      resolved.find((item) => item?.status) ||
      resolved[0] ||
      null
    );
  }

  return resolved;
};

export const isAskActive = (ask) => {
  const status = ask?.status || ask?.Status;
  if (!status || typeof status !== 'string') return false;
  const normalized = status.toLowerCase();
  return normalized === 'ongoing' || normalized === 'patch_complete';
};

export const fetchInventoryAskByStore = async (storeId) => {
  if (!storeId) {
    return null;
  }

  try {
    const config = { ...header(), params: { store_id: storeId } };
    const { data } = await axios.get(`${API_URL}/inventory/asks`, config);
    return normalizeAsk(data);
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const fetchInventoryAsksByStore = async (storeId, params = {}) => {
  if (!storeId) {
    return [];
  }

  const config = { ...header(), params: { store_id: storeId, ...params } };
  const { data } = await axios.get(`${API_URL}/inventory/asks`, config);
  const resolved = data?.response ?? data ?? [];
  return Array.isArray(resolved) ? resolved : [];
};

export const fetchInventoryAskProducts = async (askId) => {
  if (!askId) {
    return [];
  }

  const { data } = await axios.get(
    `${API_URL}/inventory/asks/${askId}/products`,
    header()
  );

  const resolved = data?.response ?? data ?? [];
  return Array.isArray(resolved) ? resolved : [];
};

export const createInventoryAsk = async (payload) => {
  const safePayload = payload || {};
  const { data } = await axios.post(`${API_URL}/inventory/asks`, safePayload, header());
  return normalizeAsk(data);
};

export const patchInventoryAskQuantity = async (askId, productId, filledQuantity) => {
  if (!askId || !productId) {
    throw new Error('askId and productId are required');
  }

  const qty = Number(filledQuantity);
  const resolvedQty = Number.isFinite(qty) ? qty : 0;
  const { data } = await axios.patch(
    `${API_URL}/inventory/asks/${askId}/products/${productId}`,
    { filled_quantity: resolvedQty },
    header()
  );
  return normalizeAsk(data);
};

export const updateInventoryAskStatus = async (askId, status) => {
  if (!askId) {
    throw new Error('askId is required');
  }
  const { data } = await axios.patch(
    `${API_URL}/inventory/asks/${askId}/status`,
    { status },
    header()
  );
  return normalizeAsk(data);
};

export default {
  fetchInventoryAskByStore,
  fetchInventoryAsksByStore,
  fetchInventoryAskProducts,
  createInventoryAsk,
  patchInventoryAskQuantity,
  updateInventoryAskStatus,
  isAskActive,
};
